import React, { useState } from 'react';
import {
  IonButton,
  IonButtons,
  IonIcon,
  IonLabel,
  IonList,
  IonTabButton,
} from '@ionic/react';
import { listCircleOutline, heartCircleOutline, refresh } from 'ionicons/icons';
import LoyaltyMypgs from 'containers/loyalty/loyaltyMyPgs';
import LoyaltyExplorePgs from 'containers/loyalty/loyaltyExplorePgs';
import { PageLayout } from 'containers/layout';
import { useDispatch } from 'react-redux';
import PayActions from 'redux/PayRedux';

export const LOYALTY_JOIN = 'loyalty_join';
export const LOYALTY_JOIN_CONFIRM = 'loyalty_join_confirm';
export const LOYALTY_STAR = 'loyalty_star';
export const LOYALTY_REDEEM = 'loyalty_redeem';
export const LOYALTY_MENU_ITEM = 'loyalty_menu_item';
export const LOYALTY_OPTOUT = 'loyalty_optout';
export const BLE_SCAN_TIP = 'BLE_SCAN_TIP';
export const BLE_SCAN_RESTART = 'BLE_SCAN_RESTART';

export const TAB_MY_PROGRAMS = 'loyalty_my_programs';
export const TAB_EXPLORE_PROGRAMS = 'loyalty_explore_programs';

function Loyalty() {
  const dispatch = useDispatch();
  const [tabItem, setTabItem] = useState(TAB_MY_PROGRAMS);

  const onExploreAction = () => {
    setTabItem(TAB_EXPLORE_PROGRAMS);
  }

  return (
    <PageLayout
      title="My Loyalty Programs"
      back="/locations"
      header={
        <IonButtons slot="end">
          <IonButton onClick={() => {
            dispatch(PayActions.loadLoyaltyPoints());
          }}
          >
            <IonIcon slot="icon-only" icon={refresh} />
          </IonButton>
        </IonButtons>
      }
      footer={
        <IonList className='tab-bar-wrap'>
          <IonButtons slot="bottom">
            <IonTabButton onClick={() => setTabItem(TAB_MY_PROGRAMS)} selected={tabItem === TAB_MY_PROGRAMS}>
              <IonIcon icon={heartCircleOutline} />
              <IonLabel className="tab-button-text-label">My Programs</IonLabel>
            </IonTabButton>

            <IonTabButton onClick={() => setTabItem(TAB_EXPLORE_PROGRAMS)} selected={tabItem === TAB_EXPLORE_PROGRAMS}>
              <IonIcon icon={listCircleOutline} />
              <IonLabel className="tab-button-text-label">Explore Programs</IonLabel>
            </IonTabButton>
          </IonButtons>
        </IonList>
      }
    >
      {
        tabItem === TAB_MY_PROGRAMS ? <LoyaltyMypgs onExploreAction={onExploreAction} /> : <LoyaltyExplorePgs />
      }
    </PageLayout>
  );
}

export default Loyalty;
